import { environment } from '../../../environments/environment';

import { Injectable, Inject } from '@angular/core';

import { LocalstorageService } from './localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class UrlHelperService {
  
    constructor(private localstorage: LocalstorageService) {

    };

    static baseUrl = environment.apiUrl;
    static login = 'Login';
    static forgotPassword = 'user/forgotpassword';
    static verifyOtp = 'user/resetpassword';
    static resetPassword = 'user/resetpassword';
    static changePassword = 'user/changepassword';
    static audit = 'audit/getauditlogs';
    static userlist = 'user/getuserlist';
    static userlisting = 'user/usersortedlist';
    static userRoles = 'user/getroleslist';
    static addUser = 'user/adduser';
    static getuserbyid = 'user/getuserbyid/';
    static updateUserPassword ='user/updateuserpassword/';
    static updateUserDetails = 'user/updateuser';
    static categoryListing = 'Category/categorysortedlist';
    static addCategory = 'Category/addcategory';
    static getcategorybyid = 'Category/getcategorbyidy/';
    static updateCategory = 'Category/updatecategory/';
    static getAllCategories = 'product/getallcategories';
    static addProduct = 'product/addproduct';
    static productListing = 'product/productsortedlist';
    static addLeftCategoryMenu = 'shop/Category/getallcategories';
    static getProductbyid = 'product/getproductdetails/';
    static uploadImage = 'product/uploadimage/';
    static productImageListing = 'product/getproductassets';
    static productSingleThumbnail = 'product/setdefaultproductimage';
    static productDeleteListing = 'product/deleteproductassets';
    static updateProductListing = 'product/updateproductinformation';
    static homePageContentListing = 'shop/product/ProductSortedList';
    static homePageImageListing = 'shop/product/getproductfirstimageurl/';
    static ProductMultipleImage = 'shop/product/getproductassets/';
    static getProductAssetContent = 'shop/product/getproductdetails/';
    static buyNowCustomerProductOrder = 'shop/order/placeorder/';
    static customerAddAddress = 'shop/address/addaddress';
    static customerAddressList = 'shop/address/GetAddressList';
    static deleteCustomerList = 'shop/address/deleteaddress';
    static upadteCustomerAddressDetail = 'shop/address/updateaddress';
    static getCityStatePostalCode = 'shop/address/getcitystatebypostalcode/';
    static getCustomerById = 'shop/address/getaddressbyid/';
    static customerOrderListing = 'shop/product/getproductdetails/';
    static confirmCustomerAddressList = 'shop/address/GetAddressList';
    static CustomerOrderDetailsListing = 'shop/order/getoderdetailincheckout/';
    static WarrantyOrderDetailsListing = 'shop/order/getoderdetailincheckout/';
    static CustomerOrderSubscriptionIntent = 'shop/order/securepaymentcheckout/';
    static CustomerPlaceOrderPayment = 'shop/order/placeorder/';
    static GetProductImageListing = 'shop/product/getproductdetails';
    static CustomerProducSingleImageListing = 'shop/product/getproductfirstimageurl/';
    static customerOrderList = 'shop/order/getorders';
    static customerOrderDetail = 'shop/order/getorderdetails/';
    static Register = 'user/registration';
    static UserVerification = 'user/veriyregistration';
    static CustomerinvoiceDetail = 'shop/order/getinvoicedetail/';
    static ResendVerifications = 'user/resenduserverification';
    static getAdminOrederListing = 'admin/getallordersbyadmin';
    static adminOrderDetail = 'admin/getorderdetailsforadmin/';
    static adminOrderStatusChange = 'admin/updateorderstatus';
    static addWarrantyService = 'warrantyservice/createwarrantyservice';
    static warrantyServiceListing = 'warrantyservice/warrantyservicesortedlist';
    static getWarrantyServicebyid = 'warrantyservice/getwarrantyservicebyid/';
    static updatewarrantyservice = 'warrantyservice/updatewarrantyService/';
    static updateproductwarrantyservice = 'product/updateproductwarrantyservice';
    static getproductWarrantyServicebyid = 'product/getwarrentyservicebyproductid/';
    static getProductWarrantyServiceList = 'shop/product/getproductwarrantyservice/';
    static addProductWarrantyService = 'shop/product/getwarrantyservicebywarrantyid/';
    static ProductWarrantyServiceDetails = 'shop/product/getwarrantyservicebywarrantyid/';
    static companyAddAddress = 'companyaddress/addaddress';
    static companyAddressList = 'companyaddress/getaddresslist';
    static getCompanyAddressrById = 'companyaddress/getaddressbyid/';
    static upadteCompanyAddressDetail = 'companyaddress/updateaddress';
    static deleteCompanyAddress = 'companyaddress/deleteaddress';
    static getAllCompanyAddress =  'product/getallcompanyaddress';
    static getOrderTotal = 'shop/dashboard/gettotalorders';
    static getTotalAmountSpend = 'shop/dashboard/gettotalamountspend';
    static getTotalOrderStatus = 'shop/dashboard/gettotalordersbystatus';
    static getActiveProductTotal = 'dashboard/getadmintotalactiveproducts';
    static getCategoryTotal = 'dashboard/getadmintotalcatgories';
    static getAdminOrderTotal = 'dashboard/getadmintotalorders';
    static getAdminEarning = 'dashboard/getadmintotalearning';
    static getAdminOrderStatus = 'dashboard/getadmintotalorderbystatus';
    static adminInvoiceOrderDetail = 'admin/getorderdetailsforadmin/';
    static getAdminLatestOrders = 'dashboard/getadminlatestorders';
    static getCustomerLatestOrders = 'shop/dashboard/getcustomerlatestorders';
    static getAdminTotalWarranty = 'dashboard/getadmintotalwarranty';
    static getCustomerTotalWarranty = 'shop/dashboard/gettotalWarrantycustomer';
    static getInActiveProductTotal = 'dashboard/getadmintotalinactiveproducts';
    static getProductTotal = 'dashboard/getadmintotalproducts';
    static getAdminQuoteListing = 'admin/getallquotebyadmin';
    static customerAddQuote = 'shop/quote/addquote';
    static quotePageImageList = 'shop/product/getproductfirstimageurl/';
    static quoteAddressList = 'admin/getquotedetailsforadmin/';
    static deleteQuoteList = 'admin/deletequote';
    static excludedStateCodeAdd = 'excludedstatecode/addstatecode';
    static excludedStateCodeAddListing = 'excludedstatecode/statecodelist';
    static getStateCodeById = 'excludedstatecode/getstatecodebyid/';
    static excludedStateCodeUpdate = 'excludedstatecode/updatestatecode';
    static deleteExcludedStateCode = 'excludedstatecode/deletestatecode';
    static relatedProductListing = 'product/relatedproductlist';
    static updateRelatedProducts = 'product/saverelatedproducts';
    static getRelatedProductbyid = 'product/getrelatedproductbyproductid/';
    static getRelatedProductList = 'shop/product/recomendedproductlist';
    static deleteRelatedProduct = 'product/removerelatedselectedproduct';
    static searchTagsListEndPoint = 'product/productsearchtagslist';
    static ReviewListing = 'shop/review/reviewlist';
    static ReviewAdd = 'review/addreview';
    static AdminReviewListing = 'review/reviewsortedlist';
    static GetReviewList = 'review/getreviewbyid/';
    static UpdateReviews = 'review/updatereview';
    static deleteReviews = 'review/deletereview';
    static uploadeReviewImage = 'review/uploadreviewimage/';
    static shopReviewImageListing = 'shop/review/reviewimageurl/';
    static getReviewsImg = 'review/getreviewassets/';
    static seoUpdateProductEndPoint = 'product/seoupdateproduct';
    static getSeoProductEndPoint = 'product/getseoproductdetails/';
    static adminDeliveryPriceUpdated = 'admin/updatedeliveryprice';
    static productImageUpdateSequenceListing = 'product/updatesequence';
    static customerReviewEndPoint = 'shop/review/addcustomerreview';
    static uploadCustomerReviewImage = 'shop/review/uploadcustomerreviewimage/';
    static accessoriesProductListing = 'product/accessoriesproductlist';
    static updateAccessoriesProducts = 'product/saveAccessoriesproducts';
    static getAccessoriesProductbyid = 'product/getaccessoriesproductbyproductid/';
    static deleteAccessoriesProduct = 'product/removeaccessoriesselectedproduct';
}


